import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

const Item = styled.div`
  padding: 0rem 1rem 0.5rem 1rem;
  position: relative;
  width: 25%;
  @media (max-width: ${props => props.theme.breakpoints.l}) {
      width: 25%;
  }
  @media (max-width: ${props => props.theme.breakpoints.m}) {
      width: 25%;
  }
  @media (max-width: ${props => props.theme.breakpoints.s}) {
      width: 100%;
  }
  font-size: 12px;
`;

const Title = styled.div`
  margin-top: 0.5rem;
  color: ${props => props.theme.colors.black};
  font-size: 1rem;
  font-weight: 700;
  line-height: 120%;
  p {
    margin-bottom: 0.5rem;
  }
`;

const BlogSummary = styled.p`
  margin-bottom: 2rem;
`;

const StyledLink = styled(Link)`
  font-style: normal;
  font-weight: normal;
  color: ${props => props.theme.colors.black};
`;

const MoreLink = styled(Link)`
  position: absolute;
  bottom: 0;
  font-style: normal;
  text-decoration: underline;
  color: ${props => props.theme.colors.lightBlue};
  font-weight: normal;
`;

export default class ListItem extends Component {
  render() {
    const { node } = this.props;
    return (
      <Item>
        <Link to={node.uid}><Img fluid={node.data.thumbnail.localFile.childImageSharp.fluid} /></Link>
        <StyledLink to={node.uid}><Title><p>{node.data.title.text}</p></Title></StyledLink>
        <BlogSummary>
          {node.data.summary.text}
        </BlogSummary>
        <MoreLink to={node.uid}>
          <p>More</p>
        </MoreLink>
      </Item>
    );
  }
}

ListItem.propTypes = {
  node: PropTypes.object.isRequired,
  categories: PropTypes.array.isRequired,
};
